// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2q_-_","right":"styles_right__3CxX1"};